import React from "react";
import MobileLinks from "./MobileLinks";
import '../Styles/MobileNavigation.scss';
import {AiOutlineMenu, AiOutlineShoppingCart} from 'react-icons/ai'
import {Link} from 'react-router-dom'
import { useState } from "react";
import logo from "../Images/BillRiceRanchCircleLogoWhite.png";
import Session from 'react-session-api';
import {useNavigate} from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import { useCart } from '../Contexts/CartContext';

function MobileNavigation() {
   const location = useLocation();
   const {pathname} = location;

   const [open, setOpen] = useState(false);
   const navigate = useNavigate();
   const { count } = useCart();

   // Matches the desktop header: the cart only exists for signed-in individual accounts, so group
   // and admin sessions never see it.
   const showCart = Session.get("isAuth") === "true" && Session.get("accountType") === "individual";
   
   const accountLogout = async () => {
      try {
      const response = await fetch('/api/logout', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })

      if (response.status === 400 || response.status === 500) {
            throw new Error("Failed Logout");
      }

      Session.set("isAuth", null)
      Session.set("accountType", null)
      
      navigate('/');
      } catch (err) {
         console.error(err.message); 
      }
   }

   return (
      <div className="mobileNavContent">
         
         <div className="mobileNavContainer">

            {/* <div className="hamburgerIcon">
               <AiOutlineMenu className="burger"
               onClick={() => setOpen(!open)}
               />
            </div> */}

            <div className="mobileIcon">
            <Link to={'/'}> <img src={logo} alt ="BRR Logo" >
                  </img></Link>
            </div>

            <div className="mobileSignIn">

               {/* Ahead of the account button so the cart sits in the top-right corner, where every
                   other site puts it. Present on phones for the same reason it is on desktop: a
                   cart nobody can reach is a cart nobody uses. */}
               {showCart &&
                  <div className="mobileCartButton">
                     <Link to={'/mycart'} id='mobileCart'
                        title="My Cart"
                        aria-label={`My cart, ${count} registration${count === 1 ? '' : 's'}`}>
                        <AiOutlineShoppingCart className="mobileCartIcon" aria-hidden="true" />
                        {count > 0 && <span className="mobileCartBadge">{count}</span>}
                     </Link>
                  </div>
               }

               <div className="button1">
                  {Session.get("isAuth") === "true" ?
                     <>
                     {(pathname === "/groupaccount" || pathname === "/individualaccount")?
                        <button onClick={accountLogout}>
                           Logout
                        </button>
                     :
                        <>
                        {Session.get("accountType") === "individual" ?
                           <Link to={'/individualaccount'} id='login'>
                              <button>
                                 My Account
                              </button>
                           </Link>
                        :
                           <Link to={'/groupaccount'} id='login'>
                              <button>
                                 My Account
                              </button>
                           </Link>
                        }
                        </>
                     }
                     </>
                  :
                     <Link to={'/selectregistration'} id='login'>
                        <button>
                           Sign In
                        </button>
                     </Link>
                  }
               </div>

            </div>
         </div>
         {open && 
               <MobileLinks/>
            }
      </div>

   );

}

export default MobileNavigation;
